import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_CARRERAS,
  ALL_CARRERAS,
  LOADING_ALL_CARRERAS,
} from './CarrerasReducer';
import {
  deleteCarrerasService,
  allCarrerasService,
  oneCarrerasService,
  saveCarrerasService,
} from './CarrerasService';

export const allCarrerasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_CARRERAS, payload: true });
    const res = await allCarrerasService(params);
    dispatch({ type: ALL_CARRERAS, payload: res.data });
    dispatch({ type: LOADING_ALL_CARRERAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_CARRERAS, payload: false });
    tryCatchHelper(e);
  }
};

export const saveCarrerasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveCarrerasService(id, data);
    notify(res.data.message);
    await allCarrerasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoCarrerasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_CARRERAS, payload: data });
};

export const oneCarrerasAction = async (dispatch, id) => {
  try {
    const res = await oneCarrerasService(id);
    await setActivoCarrerasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteCarrerasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteCarrerasService(id);
    await setActivoCarrerasAction(dispatch, null);
    notify(res.data.message);
    await allCarrerasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
